<template>
  <div class="attendance-class">
    <attendanceClassTopbar
      :today="today"
      @pickDate="pickDate"
      :className="className"
      :classPlaceholder="classPlaceholder"
      :classProps="classProps"
      :classSelect="classSelect"
      @changeHandle="changeHandle"
    />
    <div class="attendance-main">
      <attendanceItem
        :attendanceList="attendanceList"
        :pageSize="pageSize"
        :total="total"
        :getListResult="getListResult"
        @currentPageNumChange="currentPageNumChange"
        @handleSizeChange="handleSizeChange"
      />
    </div>
  </div>
</template>

<script>
import attendanceClassTopbar from "./components/attendance-topbar/attendance-topbar.vue";
import attendanceItem from "./components/attendance-item/attendance-item.vue";
export default {
  components: { attendanceClassTopbar, attendanceItem },
  data() {
    return {
      // 今天的日期
      today: "",
      attendanceDate: "",
      // 分页参数
      pageNum: 1,
      pageSize: 10,
      total: 0,
      getListResult: "nullData",
      attendanceList: [],
      // 处理后的班级年级多选数据
      classSelect: [],
      // 级联选择器属性配置
      classProps: {
        expandTrigger: "hover",
        children: "schoolClassList",
      },
      // 选中后的班级年级
      className: [],
      // 班级年级数据
      classSelectList: [],
      classPlaceholder: "",
      classData: {
        classId: "",
        className: "",
      },
    };
  },
  created() {
    // console.log(this.classInfo);
    // console.log("日期==>",this.today,this.attendanceDate);
    this.today = this.timestampToTime();
    this.attendanceDate = this.today;
    // this.getAttendanceList();
    this.selectSchoolAndGradeAndClassListPC();
  },
  methods: {
    changeHandle(e) {
      this.classData.classId = e[1].classId;
      this.classData.className = e[1].className;
      this.getAttendanceList();
    },
    // 年级和班级选择列表
    selectSchoolAndGradeAndClassListPC() {
      this.get(this.$url.getgradeList, {
        schoolId: this.user.schoolId,
      })
        .then((res) => {
          if (res.code !== 200) {
            return this.$message.error(res.msg);
          }
          // console.log(res);
          this.classSelectList = res.data;
          this.classSelectListLength = this.classSelectList.length;
          // console.log(this.classSelectList.length);
          if (this.classSelectList.length) {
            this.classSelectList.forEach((gItem, g) => {
              let { gradeCode, gradeId, gradeName } = gItem;
              gItem.value = {
                gradeCode,
                gradeId,
                gradeName,
              };
              gItem.label = gItem.gradeName;
              gItem.schoolClassList.forEach((cItem, c) => {
                let { classCode, classId, className } = cItem;
                cItem.value = {
                  classCode,
                  classId,
                  className,
                };
                cItem.label = cItem.className;
              });
            });
            this.classSelect = this.classSelectList;
            // 默认选中时的classId/className
            this.classData.classId =
              this.classSelect[0].schoolClassList[0].classId;
            this.classData.className =
              this.classSelect[0].schoolClassList[0].className;
            // 获取学生列表
            this.getAttendanceList();

            // 默认选中第一个年级班级
            let firstGrade = {};
            let { gradeCode, gradeId, gradeName } = this.classSelect[0];
            firstGrade = { gradeCode, gradeId, gradeName };
            let firstClass = {};
            let { classCode, classId, className } =
              this.classSelect[0].schoolClassList[0];
            firstClass = { classCode, classId, className };
            this.className = [firstGrade, firstClass];
            this.classPlaceholder = `${firstGrade.gradeName} / ${firstClass.className}`;
            // console.log("处理后的数据==>", this.classSelect);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$message.error("获取班级列表失败");
        });
    },
    getAttendanceList() {
      // this.getListResult = "loading";
      this.post(this.$url.teacherSelectClassAttendanceByTime, {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        classId: this.classData.classId, // 班级id 18
        className: this.classData.className, // 班级名称 "高一（1）班"
        attendanceTime: this.attendanceDate, // 考勤时间 "2021-09-06"
      })
        .then((res) => {
          // console.log("res=>", res);
          if (res.code != 200) {
            this.getListResult = "error";
            this.$message.error(res.msg);
            return;
          }
          let data = res;
          this.total = data.total;
          this.attendanceList = data.rows;
          this.total > 0
            ? (this.getListResult = "success")
            : (this.getListResult = "nullData");
        })
        .catch((err) => {
          this.getListResult = "error";
          this.$message.error("获取考勤列表失败,请稍后再试！");
        });
    },
    // 页数选择
    currentPageNumChange(e) {
      this.pageNum = e;
      this.getAttendanceList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getAttendanceList();
    },
    // 日期选择
    pickDate(e) {
      // console.log("选择的日期==>",e);
      this.attendanceDate = e;
      this.getAttendanceList();
    },
    timestampToTime() {
      var date = new Date(); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate();
      return Y + M + D;
    },
  },
};
</script>

<style scoped lang="scss">
@import "./attendance-class.scss";
</style>